import {
  TRANSACTION_GET_LIST,
  TRANSACTION_REQUEST,
  TRANSACTION_SUCCESS,
  TRANSACTION_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  transactions: null,
  page: 1,
  totalCount: 0,
  search: "",
  isLoading: false,
  error: null
}

const getters = {
  getTransactions: (state) => state.transactions,
  getTransactionSearchTerm: (state) => state.search,
  getTransactionCurrentPage: (state) => state.page,
  getTransactionTotalCount: (state) => state.totalCount,
  isTransactionLoading: (state) => state.isLoading,
  getTransactionError: (state) => state.error
}

const actions = {
  [TRANSACTION_GET_LIST]: ({ commit }, { page = 1, search = "" }) => {
    return new Promise((resolve, reject) => {
      commit(TRANSACTION_REQUEST)

      axios
        .get(
          `/api/v3/transactions/?page=${page}${
            search ? `&search=${search}` : ""
          }`
        )
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          resp.data.page = page
          commit(TRANSACTION_SUCCESS, resp.data)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(TRANSACTION_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [TRANSACTION_REQUEST]: (state) => {
    state.isLoading = true
  },
  [TRANSACTION_SUCCESS]: (state, transactions) => {
    state.isLoading = false

    if (transactions) {
      state.transactions = transactions.results
      state.page = transactions.page
      state.totalCount = transactions.count
    }
  },
  [TRANSACTION_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
